/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Final/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconCheckFilled from 'DesignSystem/Svgs/TysiaIconCheckFilled/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagIcon from 'DesignSystem/TysiaTag/TysiaTagIcon/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'



/** @type {import('Simple/types.js').View} */
export default function Final({
  children,
  viewPath = "/DesignSystem/GenerateLettersModal/Content/Letters/Letter/Status/Final"
  
}) {
let dtColorsGreen200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.200'
        })
let dtColorsGreen900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.900'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 alignSelf="auto"
 cursor="pointer"
 backgroundColor={dtColorsGreen200}
 borderColor={dtColorsGreen200}
 color={dtColorsGreen900}
>
{childProps => (
<React.Fragment>
<TysiaTagIcon
{...childProps}
  viewPath={`${viewPath}/TysiaTagIcon`}
>
{childProps => (
<TysiaIconCheckFilled
{...childProps}
  viewPath={`${viewPath}/TysiaIconCheckFilled`}
 fill={dtColorsGreen900}
 marginLeft={0}
 marginRight={dtSpaceXxs}
 width={16}
 height={16}
/>
)}
</TysiaTagIcon>
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Final"
/>
</React.Fragment>
)}
</TysiaTag>
{children}
</React.Fragment>)
}